export default "__VITE_ASSET__CbCceYdg__"